<template>
  <div class="usual-content">
    <div v-for="(item,index) in data"
         :key="index">
      <p class="usual-question">
        <span class="q-icon"></span>
        <span>{{item.title}}</span>
      </p>
      <p>{{item.answer}}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Qa',
  props: {
    type: String
  },
  data () {
    return {
      qaType: '',
      liveQa: [{
        title: '质心客服电话是多少？',
        answer: '客服电话：010-80455397,010-89631145，工作时间10:00 - 19:00，周六日不休。'
      }, {
        title: '是否可以退费或者换课？',
        answer: '目前不支持换课功能；少部分课程不支持退费，大部分课程支持，退费规则为：直播课开始前30分钟以上，可以退费，否则不可退费。课程费用将原路退还到您付款所用的支付宝/微信账户；回放课程不支持退费。'
      }, {
        title: '课程观看有效期是多久？',
        answer: '若购买回放课，则从购买之日起1年内有效；若购买直播课，则在课程直播之日起1年内有效，在有效期内可无限次回看。到期后，课程将无法继续观看学习，且均不支持续期。建议大家合理安排时间及时观看。'
      }, {
        title: '直播课程与回放课程有什么区别？',
        answer: '在直播课程中，同学们可以随时提问，老师和助教会进行答疑。为了达到最好的学习效果，建议同学们尽可能参与直播课程。'
      }, {
        title: '哪些课程会邮寄资料？',
        answer: '部分系统课和专题课会邮寄资料，以各课程的课程详情说明为准。如果需要邮寄资料，在确认订单前会有填写收货地址的步骤，请放心。'
      }, {
        title: '购买后如果要退款，需要把课程资料寄回质心吗？',
        answer: '分两种情况：第一，课程部分退款，这时不需要寄回资料。第二，课程全额退款，则需要寄回资料。'
      }],
      mianshouQa: [
        {
          title: '你们的特色是什么？',
          answer: '全部师资均来源于985等名校。'
        },
        {
          title: '如何联系质心灵动量线下客服？',
          answer:
            '1.可以关注微信公众号“质心灵动量”，对话框输入“客服”，扫码添加客服。2.拨打前台电话0755-83502250。'
        },
        {
          title: '是否可以试听？',
          answer:
            '第一节为免费试听课，试听后，如不满意不收取任何费用（需提前联系客服预约）。'
        },
        {
          title: '校区地址在哪里？',
          answer: '深圳市福田区园岭街道园东社区红岭中路红岭商业楼302。'
        },
        {
          title: '购课后如何退款？',
          answer: '联系客服，可随时退款（特价班除外），2周内可实现退款。已上完的课程及新购买的回放课程不支持退费，课程配套教材费用不支持退费。'
        }
      ]
    }
  },
  computed: {
    data () {
      switch (this.qaType) {
        case 'live':
          return this.liveQa
        case 'offline':
          return this.mianshouQa
        default:
          return []
      }
    }
  },
  mounted () {
    this.qaType = this.type
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_base.scss";
$text: #333;

.usual-content {
  @media (max-width: 767px) {
    padding: 16px;
  }

  p {
    color: $gray-base;
    text-align: justify;
    margin-bottom: 15px;
  }
  .usual-question {
    font-weight: bold;
    font-size: 15px;
  }
  .usual-question + p {
    margin-bottom: 30px;
  }
  .q-icon {
    display: inline-block;
    width: 18px;
    height: 18px;
    background: url(https://cdn.eduzhixin.cn/cdn/img/icons/icon_question-c642c5fa.png)
      no-repeat center;
    background-size: cover;
    vertical-align: top;
    margin-right: 10px;
  }
}
</style>
